/* eslint-disable react/prop-types */
import React, { forwardRef, useEffect, useState } from 'react'
import clsx from 'clsx'
import { isFragment } from 'react-is'
import './GenericPortlet.module.scss'

export const PortletHeaderTitle = forwardRef(({ className, ...props }, ref) => (
  // eslint-disable-next-line jsx-a11y/heading-has-content
  <span {...props} ref={ref} className={clsx('Uic-GenericPortlet-headTitle', className)} />
))

export const PortletHeaderToolbar = forwardRef(({ className, ...props }, ref) => (
  <div {...props} ref={ref} className={clsx('Uic-GenericPortlet-headToolbar', className)} />
))

export const PortletHeader = forwardRef(
  ({ icon, title, extraTitle, toolbar, className, sticky = false, labelRef }, ref) => {
    const [top, setTop] = useState(0)
    const [windowHeight, setWindowHeight] = useState(0)

    useEffect(() => {
      // eslint-disable-next-line no-use-before-define
      handleResize()

      function handleResize() {
        setWindowHeight(window.innerWidth)
      }

      window.addEventListener('resize', handleResize)

      return () => {
        window.removeEventListener('resize', handleResize)
      }
    })

    useEffect(() => {
      // Skip if sticky is disabled or on initial render when we don't know about window height.
      if (!sticky || windowHeight === 0) {
        return
      }

      const headerElement = document.querySelector('.header')
      const subheaderElement = document.querySelector('.subheader')
      const headerMobileElement = document.querySelector('.header-mobile')

      let nextMarginTop = 0

      // mobile header
      if (window.getComputedStyle(headerElement).height === '0px') {
        nextMarginTop = headerMobileElement.offsetHeight
      } else {
        // desktop header
        // eslint-disable-next-line no-lonely-if
        if (document.body.classList.contains('header--minimize-topbar')) {
          // hardcoded minimized header height
          nextMarginTop = 60
        } else {
          // normal fixed header
          if (document.body.classList.contains('header--fixed')) {
            nextMarginTop += headerElement.offsetHeight
          }

          if (document.body.classList.contains('subheader--fixed')) {
            nextMarginTop += subheaderElement.offsetHeight
          }
        }
      }

      setTop(nextMarginTop)
    }, [sticky, windowHeight])

    return (
      <div
        ref={ref}
        className={clsx('Uic-GenericPortlet-head', className)}
        style={!sticky ? undefined : { top, position: 'sticky', backgroundColor: 'var(--bs-body-bg, #fff)' }}
      >
        {title != null && (
          <div ref={labelRef} className="Uic-GenericPortlet-headLabel">
            <h3 className="Uic-GenericPortlet-headTitle">
              {icon}

              {
                /* Wrap string and fragments in PortletHeaderTitle */
                typeof title === 'string' || isFragment(title) ? (
                  <PortletHeaderTitle>
                    {title} {extraTitle != null && <span className="Uic-GenericPortlet-darkGrey">{extraTitle}</span>}
                  </PortletHeaderTitle>
                ) : (
                  title
                )
              }
            </h3>
          </div>
        )}

        {toolbar}
      </div>
    )
  },
)

export const PortletBody = forwardRef(({ fit, fluid, className, ...props }, ref) => (
  <div
    {...props}
    ref={ref}
    className={clsx(
      'Uic-GenericPortlet-body',
      {
        'Uic-GenericPortlet-bodyFit': fit,
        'Uic-GenericPortlet-bodyFluid': fluid,
      },
      className,
    )}
  />
))

export const PortletFooter = forwardRef(({ className, ...props }, ref) => (
  <div {...props} ref={ref} className={clsx('Uic-GenericPortlet-foot', className)} />
))

export const Portlet = forwardRef(({ fluidHeight, className, ...props }, ref) => (
  <div
    {...props}
    ref={ref}
    className={clsx('Uic-GenericPortlet-portlet', { 'Uic-GenericPortlet-heightFluid': fluidHeight }, className)}
  />
))
